import { TONE } from "./data";

export function StatusBar({ dark, time = "6:02" }) {
  const c = dark ? "#fff" : "var(--charcoal)";
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "52px 72px 0", color: c, fontSize: 38, fontWeight: 600 }}>
      <span>{time}</span>
      <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
        <div style={{ display: "flex", gap: 5, alignItems: "flex-end" }}>
          {[14, 20, 26, 32].map((h) => <span key={h} style={{ width: 8, height: h, background: c, borderRadius: 2 }} />)}
        </div>
        <div style={{ width: 62, height: 30, border: `4px solid ${c}`, borderRadius: 9, padding: 3 }}>
          <div style={{ width: "72%", height: "100%", background: c, borderRadius: 3 }} />
        </div>
      </div>
    </div>
  );
}

export function HomeBar({ dark }) {
  return <div style={{ position: "absolute", bottom: 26, left: "50%", transform: "translateX(-50%)", width: 300, height: 10, borderRadius: 6, background: dark ? "rgba(255,255,255,.7)" : "var(--ink-40)" }} />;
}

export function Wordmark({ size = 64, sub }) {
  return (
    <div style={{ display: "flex", alignItems: "baseline", gap: 18 }}>
      <span className="wordmark" style={{ fontSize: size, lineHeight: 1 }}>marova</span>
      {sub && <span style={{ fontSize: size * 0.34, color: "var(--ink-40)", fontWeight: 500, letterSpacing: "0.02em" }}>{sub}</span>}
    </div>
  );
}

export function Chip({ tone = "blush", children, size = 30 }) {
  const t = TONE[tone];
  return (
    <span style={{ background: t.bg, color: t.fg, padding: `${size * 0.5}px ${size * 0.9}px`, borderRadius: 999, fontSize: size, fontWeight: 500, whiteSpace: "nowrap" }}>
      {children}
    </span>
  );
}

export function Button({ children, tone = "burgundy", size = 36, style }) {
  const bg = tone === "burgundy" ? "var(--burgundy)" : "#fff";
  const fg = tone === "burgundy" ? "var(--porcelain)" : "var(--charcoal)";
  return (
    <div style={{ background: bg, color: fg, border: tone === "burgundy" ? "none" : "2px solid var(--ink-12)", borderRadius: 999, padding: `${size * 0.85}px 0`, textAlign: "center", fontSize: size, fontWeight: 600, ...style }}>
      {children}
    </div>
  );
}

export function Check({ size = 200 }) {
  return (
    <div style={{ width: size, height: size, borderRadius: "50%", background: "var(--mint)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <svg width={size * 0.5} height={size * 0.5} viewBox="0 0 24 24" fill="none" stroke="#1F5C3A" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12.5l4.5 4.5L19 7.5" />
      </svg>
    </div>
  );
}
